export const en_US: Record<string, any> = {
  pluginName: 'Global State',
};
